module.exports = __webpack_public_path__ + "static/media/X49MK2--logo.a9f65b74.svg";


//////////////////
// WEBPACK FOOTER
// ./src/X49MK2/X49MK2--logo.svg
// module id = 354
// module chunks = 0